//#region types
import { StyleEnums } from "models/enums";
import { ContentTree, ContentTreeNode } from "models/utilTypes/contentTreeTypes";
import cssExports from "theme/styles/main.module.scss";
//#endregion

function useEULADetails() {
  const getEULADetails = () => {
    const EULADetails: ContentTree[] = [
      {
        mainText: "Om Wints plattform",
        subTree: [
          "För ett tag sedan kom det en undersökning om att svenska företagare administrerar en vecka per månad. Det låter inte sunt. Det vill vi med vår plattform förändra. Tanken är att du som användare ska få en mer digital vardag. Inte behöva lägga tid på att sprätta kuvert eller sortera kvitton. Inte lägga tid på leta årsredovisningar till ett bankbesök eller fylla en pärm till redovisningskonsulten. Vi vill försöka jobba bort allt sådant. Och så vill vi göra det enklare också. Alla förstår inte en resultat och balansräkning. Men en graf förstår i alla fall fler. Vi vill göra ett företags ekonomi tydligt.",
        ],
      },
      {
        mainText: "Allmänt och definitioner",
        subTree: [
          "Dessa allmänna villkor (”Allmänna Villkor”) gäller vid användning av Wints plattform. Plattformen ägs av oss, WINT AB, org.nr. 556729-4755. Vi ger våra kunder en icke-exklusiv rätt att använda plattformen för internt bruk. Det vi begär i utbyte är att den kund som använder plattformen (”Du”) ställer upp på samt accepterar dessa Allmänna Villkor och våra övriga instruktioner för hur plattformen ska användas. För att göra det enkelt så accepterar och godkänner du våra vid var tid gällande Allmänna Villkor när du använder plattformen.",
          <>
            {
              "Dessa Allmänna Villkor gäller från och med att du godkänt dem men vi har rätt att ändra dem och eventuella ändringar träder i kraft trettio (30) dagar efter att de publiceras i plattformen. Den senast uppdaterade versionen av villkoren finns tillgänglig på "
            }
            <a href={"https://www.wint.se/info/allmanna-villkor"} className={cssExports.linkText}>
              {"https://www.wint.se/info/allmanna-villkor"}
            </a>
          </>,
          "Om sammanhanget eller omständigheterna inte uppenbarligen föranleder annat ska följande ord och begrepp anses ha den innebörd som anges nedan.",
          "Med ”Tredjepartsoperatör” avses en annan part som tillhandahåller programvara till plattformen. ",
          "Med ”Din data” avses den data eller annan information som du eller annan på uppdrag av dig gör tillgänglig för oss genom plattformen eller på annat sätt.",
          "Med ”Din Programvara” avses den programvara som ägs av dig eller som du har rätt nyttja enligt licensavtal och som används i plattformen.",
        ],
        messageBubbles: [
          {
            header: "Kort sagt...",
            children:
              "Du måste följa dessa Allmänna Villkor om du har tänkt använda plattformen. Det ska inte vara allt för krångligt.",
            displayType: StyleEnums.DisplayType.Info,
          },
        ],
      },
      {
        mainText: "När du använder plattformen",
        subTree: [
          "Endast de personer som godkänts av dig har rätt att använda plattformen. Såväl du som de du låter använda plattformen ska följa dels dessa Allmänna Villkor samt dels våra övriga instruktioner för hur plattformen får användas. Det är du som ansvarar för allt användande av din profil i plattformen.",
          "Du får inte kopiera eller på annat sätt göra programvara som ingår i plattformen tillgänglig för någon annan.",
          "Du får inte heller använda, kopiera eller på annat sätt göra annat än uppgifter om dig som återfinns i plattformen tillgängligt för någon annan.",
          "Du ansvarar för att (i) din data är fri från virus, trojaner, maskar eller annan skadlig programvara eller kod, (ii) att din data är i överenskommet format, samt (iii) att din data på annat sätt inte kan skada eller inverka negativt på plattformen.",
          "Du ansvarar själv för att inloggningsuppgifter, säkerhetsmetoder och annan information som du har för att få tillgång till plattformen, hanteras med sekretess. Du ska omedelbart meddela oss om någon.",
        ],
        messageBubbles: [
          {
            header: "Kort sagt...",
            children:
              "Använd plattformen enligt dessa Allmänna Villkor och våra övriga instruktioner så ska allt vara lugnt.",
            displayType: StyleEnums.DisplayType.Info,
          },
          {
            header: "Tänk på...",
            children:
              "att hålla lösenord och inloggningsuppgifter hemliga, det är ju inte kul om någon obehörig loggar in!",
            displayType: StyleEnums.DisplayType.Warning,
          },
        ],
      },
      {
        mainText: "Immateriella rättigheter",
        subTree: [
          "Alla immateriella rättigheter till plattformen och det som finns i plattformen (t.ex. programvara, varumärken och design), ägs av oss eller Tredjepartsoperatör. Du får bara använda plattformen för ditt interna bruk, d.v.s. inte sälja tjänsten vidare till någon annan. Självklart kan du presentera dina siffror för andra när du behöver det.",
          new ContentTreeNode(
            "Alla immateriella rättigheter till din data äger givetvis du. Vi samlar in data kopplat till ditt användande av våra tjänster för att förbättra och felsöka våra tjänster. Sådan data innefattar exempelvis",
            [
              "information om din interaktion med våra tjänster. Till exempel vilka funktioner som du använder i våra plattformar.",
              "tekniska data, vilket kan innefatta URL-information, din IP-adress, nätverksinformation samt de typer av enheter du använder för att få tillgång till våra plattformar.",
            ]
          ),
          "Du får inte i plattformen publicera eller på annat sätt göra information som är sekretessbelagd eller att anse som företagshemlighet tillgänglig om detta innebär att du eller vi gör intrång i någon annans rätt eller bryter mot någon lagstiftning.",
        ],
        messageBubbles: [
          {
            header: "Kort sagt...",
            children: "Vi äger plattformen, du äger din information.",
            displayType: StyleEnums.DisplayType.Info,
          },
        ],
      },
      {
        mainText: "Säkerhet",
        subTree: [
          "För att få tillgång till plattformen måste personnummer uppges för de som skall använda tjänsten vilka sedan loggar in med mobilt bank-id. Det är den eller de som utsetts till administratör som ansvar för att endast lägga upp behöriga personer i systemet samt med rätt behörighet.",
          "I det fall samtliga användare inte har möjlighet att logga in med mobilt bank-id kan bolaget kontakta Wint för att koppla bort krav på mobilt bank-id. För att få tillgång till plattformen måste du då ange ett lösenord som ska användas när du loggar in. För att inte andra ska kunna logga in på ditt konto är det viktigt att du håller lösenordet hemligt, du ansvarar därför för att ingen annan ska få tag på det. Eftersom vi inte kan kontrollera om du sprider lösenordet till utomstående och obehöriga så kan vi inte ta något ansvar för att någon annan loggar in på ditt konto med ditt lösenord. Skulle du ana att någon listat ut eller på något annat sätt fått reda på ditt lösenord så kontakta oss så snabbt som det går så försöker vi lösa situationen på bästa sätt. ",
          <>
            {
              "Din data kommer att lagras i en molntjänst tillhandahållen av en Tredjepartsoperatör, mer bestämt i Microsoft molntjänst Windows Azure vilken i sin tur drivs av Microsoft Global Foundation Services. Microsoft har ett bra skydd för den information som lagras i deras molntjänster. För mer information om dessa åtgärder och nivåer, se: "
            }
            <a
              href={`https://www.windowsazure.com/en-us/support/legal/subscription-agreement/`}
              className={cssExports.linkText}
            >
              {"www.windowsazure.com/en-us/support/legal/subscription-agreement/"}
            </a>
            {" samt "}
            <a href={`https://www.windowsazure.com/en-us/support/trust-center/`} className={cssExports.linkText}>
              {"www.windowsazure.com/en-us/support/trust-center/"}
            </a>
            {"."}
          </>,
        ],
      },
      {
        mainText: "Friskrivning",
        subTree: [
          "Vi och Tredjepartsoperatörerna tar inget ansvar för den information som är tillgänglig för dig i plattformen. Därför är vi aldrig skyldiga att utge ersättning för, bland annat, men inte uteslutande; inkomstbortfall, dataförlust, förlorad goodwill, eller andra skador och kostnader av vilket slag de än må vara som beror på ditt användande av plattformen eller den information eller det material som finns däri.",
          "Du ska inte fatta beslut enbart på grund av de råd och tips som du får i plattformen. De är endast till för att ge dig förslag på eventuella förbättringar för din verksamhet. Det är dock upp till dig att se till att de beslut du fattar för din verksamhet fattas på tillräckligt underlag. Vi ansvarar inte för t.ex. inkomstbortfall, dataförlust, förlorad goodwill, eller andra skador och kostnader av vilket slag de än må vara som beror på att du följt råd eller tips som du tagit del av i samband med att du använder plattformen.",
        ],
        messageBubbles: [
          {
            header: "Tänk på...",
            children: (
              <>
                {
                  "att den information och de råd, tips och förslag som du ser och får i plattformen behöver ses över mer noggrant innan du fattar några beslut."
                }
                <br /> <br />
                {
                  "Plattformen är till för att underlätta ditt arbete och vi kan tyvärr inte garantera att det du ser och hör i plattformen är helt korrekt."
                }
              </>
            ),
            displayType: StyleEnums.DisplayType.Info,
          },
        ],
      },
      {
        mainText: "Ditt ansvar",
        subTree: [
          "I det fall du via plattformen och/eller Tredjepartsapplikation attesterar och/eller fakturerar ansvarar du givetvis för det du gör. Du ansvarar även för att din data är korrekt. Ja, du ansvarar egentligen för allt som du eller annan du låter använda din inloggning gör i plattformen.",
        ],
      },
      {
        mainText: "Personuppgifter",
        subTree: [
          "Behandling av personuppgifter som sker inom ramen för vårt uppdrag till dig, däribland att tillhandahålla plattformen, regleras av separat personuppgiftsbiträdesavtal.",
          <>
            {"Övrig information om hur vi behandlar personuppgifter finns i vår integritetspolicy "}
            <a href={`https://www.wint.se/info/privacy-policy`} className={cssExports.linkText}>
              {"https://www.wint.se/info/privacy-policy"}
            </a>
          </>,
        ],
      },
      {
        mainText: "Tredjepartsapplikationer",
        subTree: [
          "Genom att integrera plattformen med applikationer som tillhör Tredjepartsoperatörer har vi lyckats fixa en del schyssta funktioner. Som du säkert förstår så kan vi dock inte garantera att dessa applikationer fungerar felfritt och kan därför inte ansvara för något användande eller funktioner som har med dessa att göra. Men vi gör vårt bästa för att försöka få det att fungera så bra som det bara går!",
        ],
      },
      {
        mainText: "Servicenivå",
        subTree: [
          "Vi arbetar nästan dygnet runt för att plattformen ska vara tillgänglig nästan jämt. Men vi använder oss av Microsofts molntjänst Azure och behöver även lite tid till att fixa och trixa med gamla och nya funktioner, administrera tjänsten och om något inte fungerar behöver vi göra felsökningar. Så vi kan inte lova att plattformen är tillgänglig 24 timmar, 7 dagar i veckan. Vår ambition är dock att plattformen ska vara tillgänglig när Microsoft Azure är tillgängligt minus ungefär 20 timmar i veckan för uppdatering och administration. Det betyder dock inte att plattformen är stängd i den utsträckningen varje vecka.",
          "Wint förbehåller sig rätten att göra ändringar i tjänsten och utveckla serviceutbudet löpande.",
        ],
      },
      {
        mainText: "Avstängning",
        subTree: [
          "Om du trots allt skulle bryta mot dessa Allmänna Villkor eller våra övriga instruktioner för plattformen, eller om vi har skälig anledning att misstänka att du gör det, så har vi rätt att omedelbart stänga av din åtkomst till plattformen. Detsamma gäller om du upphör att vara kund hos oss. Självklart har du i så fall rätt att få all din data exporterad i ett format som vi kommer överens om så att du har möjlighet att fortsätta hantera din data någon annanstans.",
        ],
      },
      {
        mainText: "Ersättning",
        subTree: [
          "Tilläggstjänster inom plattformen, som till exempel utskrift och frankering av fakturor (”Utskriftstjänst”) kan vara förknippade med styckkostnader. Dessa kostnader framgår dock när du använder eller aktiverar en tilläggstjänst.",
        ],
      },
      {
        mainText: "Överlåtelse",
        subTree: [
          "Eftersom plattformen är till för just dig så har du inte rätt att överlåta eller pantsätta dina rättigheter och/eller skyldigheter enligt dessa Allmänna Villkor.",
        ],
      },
      {
        mainText: "Kakor",
        subTree: [
          <>
            {
              "Om du kommer på besök hos så bjuder vi på kakor! Men det är inte vad som är viktigt under denna punkt. Kakor är även textfiler som sparas på din dator när du besöker våra hemsidor och plattformen. Kakorna sparas på din dator för att webbplatsen ska kunna konstatera att du är inloggad i plattformen när du byter sida och för att plattformen ska fungera så smidigt som möjligt för dig. Om du vill, så kan du alltid, genom att ändra inställningarna i din webbläsare, stänga av sparandet av kakorna. Kom dock ihåg plattformens funktionalitet kan försämras om du gör det. Mer information om hur vi använder kakor finns i vår Cookiepolicy, på vår hemsida "
            }
            <a href={`https://www.wint.se/info/cookies`} className={cssExports.linkText}>
              {"https://www.wint.se/info/cookies"}
            </a>
          </>,
        ],
      },
      {
        mainText: "Begränsning av åtkomst",
        subTree: [
          "Vi gör givetvis vårt bästa för att plattformen ska vara så säker som möjligt. Men ibland kan man inte rå för allt. Om vi känner att plattformen kan medföra skada eller risk för skada för oss eller för dig har vi därför rätt att stänga av eller begränsa åtkomsten till plattformen. Gör vi det kommer vi självklart meddela dig så snart som möjligt.",
        ],
      },
      {
        mainText: "Avtalstid och förtida upphörande",
        subTree: [
          "Dessa Allmänna Villkor gäller till dess du upphör att använda plattformen eller till dess vi ändrar dem.",
          "Tyvärr kan man inte alltid förutse framtiden. Vi kan därför inte garantera att vi alltid kommer kunna tillhandahålla plattformen. Vi har därför rätt att stänga ner plattformen. ",
        ],
      },
      {
        mainText: "Tillämplig lag, tvist",
        subTree: [
          "På dessa Allmänna Villkor ska svensk lag tillämpas. Tvist i anledning av dessa Allmänna Villkor ska avgöras i allmän domstol. Det vore dock riktigt tråkigt om något skulle gå så långt som till en domstol. Så har du några funderingar eller inte är nöjd med plattformen så är du alltid välkommen att höra av dig till oss för att hitta en lösning!",
        ],
      },
    ];

    return EULADetails;
  };

  return { getEULADetails };
}

export default useEULADetails;
